import { formatCalendarDate } from 'src/utils/DateUtils';

import { uncoveredServices } from '../../domain/services/uncoveredServices';
import { watchHeldItems } from '../../infrastructure/api/billingItemApi';
import { payerNamesAt } from '../../infrastructure/api/payerNameApi';
import { useLatestWatch } from './useLatestWatch';
import { viewerToday } from './viewerToday';

/**
 * The facts behind a client's authorization hold, as lines a biller can act on: the payer and code,
 * and the service dates no authorization covers. Followed while the task is shown, so a letter
 * entered for one payer clears that payer's lines.
 *
 * @param {() => {clinicId: string|null, clientId: string|null, holdReason: string}|null} subject
 */
// eslint-disable-next-line import/prefer-default-export
export function useUncoveredServices(subject) {
  const { value: lines, reading } = useLatestWatch(
    () => {
      const { clinicId, clientId, holdReason } = subject() ?? {};

      return clinicId && clientId && holdReason ? { clinicId, clientId, holdReason } : null;
    },
    (params, onValue, onError) => {
      const payerNames = payerNamesAt(params.clinicId, viewerToday());

      return watchHeldItems(params, (items) => payerNames.then((names) => onValue(
        uncoveredServices(items).map((line) => ({
          ...line,
          payerName: names.get(line.fundingSourceId) ?? null,
          fromLabel: formatCalendarDate(line.from),
          toLabel: formatCalendarDate(line.to),
        })),
      ), onError), onError);
    },
    { initial: [], label: 'what an authorization hold covers' },
  );

  return { lines, reading };
} // useUncoveredServices()
